module.exports = __webpack_public_path__ + "img/user-header.775a8d2.png";